import fetch                from '../../../utils/browser-fetch';
import busyActionFactory    from '../../../busy';
import { addError }         from '../../../errors-dux';
import Errors               from '../../../errors';
import { addSuccessString } from '../../../success-dux';
import SuccessString        from '../../../success';

/******************
 * Initial state
 */
const initialState = {
    busy: false
};

/******************
 * Non-async action types
 */
export const BUSY_SAVE_PASSWORD = 'BUSY_SAVE_PASSWORD';

/******************
 * Reducer
 */
export default function resetData( state = initialState, action ) {
    switch ( action.type ) {
        case BUSY_SAVE_PASSWORD:
            return {
                ...state,
                busy: action.busy
            };
        default:
            return state;
    }
}

/******************
 * Action creators
 */

const busySavePassword = busyActionFactory( BUSY_SAVE_PASSWORD );
export function savePassword( password, passwordGuid ) {
    const message = 'resetPassword.form.successMessage';
    return dispatch => {
        dispatch( busySavePassword( true ) );

        return fetch( '/api/v1.0/savePassword', {
            method: 'post',
            body: {
                'password': password,
                'passwordGuid': passwordGuid
            }
        } )
            .then( () => {
                dispatch( addSuccessString( true, message, SuccessString.SUCCESS_RESET_PASSWORD ) );
                dispatch( busySavePassword( false ) );
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_RESETPASSWORD_SETPASSWORD ) );
                dispatch( busySavePassword( false ) );
            } );
    };
}
